export const getAddressFromCoords = async (lat: number, lng: number): Promise<string | null> => {
    try {
        const geocoder = new window.google.maps.Geocoder();
        const latlng: google.maps.LatLngLiteral = { lat: lat, lng: lng };

        const results = await new Promise<google.maps.GeocoderResult[]>((resolve, reject) => {
            geocoder.geocode({ location: latlng, language: 'es-419' }, (results, status) => {
                if (status === 'OK' && results != null) {
                    resolve(results);
                } else {
                    console.log("Geocoding API error ", status, results);
                    reject(new Error(`Geocoding failed: ${status}`));
                }
            });
        })
        return results[0]?.formatted_address || null;
    } catch (error) {
        console.error("Error fetching address:", error);
        return null;
    }
};
